export default __webpack_public_path__ + "static/media/Clothes_2021.a140188d.mp4";